import type { WireBacklink } from "@archlang/viewer-core";

/**
 * Look up the backlink list for an element from the wire record, trying the
 * candidate keys in order (most specific first) and returning the first
 * non-empty hit. The serializer keys each element under its `#id`, qualified
 * name, and short name, so passing all three resolves regardless of which the
 * model has.
 */
export function lookupBacklinks(
  record: Readonly<Record<string, readonly WireBacklink[]>> | undefined,
  keys: readonly (string | undefined)[],
): readonly WireBacklink[] {
  if (!record) return [];
  for (const k of keys) {
    if (!k) continue;
    const hit = record[k];
    if (hit && hit.length > 0) return hit;
  }
  return [];
}
